/* 财务-专线包车 */
<template>
  <div id="financial">
    <custom-table ref="customTable" :has-organization="true" :customOptions="customOptions" :columns="columns"
       labelWidth="95" excel-type="IntercityFlowing" :summaryList="[
        { name: 'orderFee', beforeUnit: '￥' },
        { name: 'couponFee', beforeUnit: '￥' },
        { name: 'realFee', beforeUnit: '￥' },
        { name: 'driverIncome', beforeUnit: '￥' },
        { name: 'companyIncome', beforeUnit: '￥' },
      ]">
      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'created'">{{
          row.created | filterTime("YYYY-MM-DD HH:mm")
        }}</template>
        <template v-else-if="item.prop === 'realFee'">
          <span class="util-money" v-if="row.realFee || row.realFee === 0">¥{{
            row.realFee
          }}</span>
          <span v-if="!row.realFee && row.realFee !== 0">-</span>
        </template>
        <template v-else-if="item.prop === 'orderFee'">
          <span class="util-money" v-if="row.orderFee || row.orderFee === 0">{{
            row.orderFee
          }}</span>
          <span v-if="!row.orderFee && row.orderFee !== 0">-</span>
        </template>
        <template v-else-if="item.prop === 'couponFee'">
          <span class="util-money" v-if="row.couponFee || row.couponFee === 0">{{ row.couponFee }}</span>
          <span v-if="!row.couponFee && row.couponFee !== 0">-</span>
        </template>
        <template v-else-if="item.prop === 'channelAlias'">
          <span>{{ row[item.prop] | filterConst("CHANNELALIAS") }}</span>
        </template>
        <template v-else-if="item.prop === 'licenseNo'">
          <span v-if="row.licenseNo" :style="getPlateStyle(row.licenseNo)">{{ formatPlateNumber(row.licenseNo) }}</span>
          <span v-else>-</span>
        </template>
        <template v-else-if="item.prop === 'lineFee'">
          <span class="util-money" v-if="row.lineFee || row.lineFee === 0">{{
            row.lineFee
          }}</span>
          <span v-if="!row.lineFee && row.lineFee !== 0">-</span>
        </template>
        <template v-else-if="item.prop === 'driverIncome'">
          <template v-if="row.driverIncome || row.driverIncome === 0">
            <span class="util-money">¥{{ row.driverIncome }}</span>
            <span v-if="row.commissionRuleType == 1">
              {{
                row.proportion ? "(" + row.proportion + "%提成" + ")" : ""
              }}</span>
            <span v-if="row.commissionRuleType == 2"> (定额提成)</span>
          </template>

          <span v-if="!row.driverIncome && row.driverIncome !== 0">-</span>
        </template>
        <template v-else-if="item.prop === 'companyIncome'">
          <span class="util-money" v-if="row.companyIncome || row.companyIncome === 0">¥{{ row.companyIncome }}</span>
          <span v-if="!row.companyIncome && row.companyIncome !== 0">-</span>
          {{
            row.refundProportion
            ? "(" + row.refundProportion + "%退票费率" + ")"
            : ""
          }}
          {{
            row.ticketChangingProportion
            ? "(" + row.ticketChangingProportion + "%改签费率" + ")"
            : ""
          }}
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>
  </div>
</template>

<script>
export default {
  name: "financial",
  data() {
    return {
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/financeFlowing/intercity",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          { type: "input", field: "serialNo", name: "流水号", value: "" },
          { type: "input", field: "orderNo", name: "订单号", value: "" },
          { type: "input", field: "driverName", name: "司机姓名", value: "" },
          { type: "input", field: "licenseNo", name: "车辆号牌", value: "" },
          { type: "input", field: "vehicleNo", name: "车辆编号", value: "" },
          { type: "datetime", field: "time", name: "记录时间", value: [new Date().setHours(0, 0, 0, 0) - 3600 * 1000 * 24 * 30, new Date().setHours(23, 59, 59, 0)] },
        ],
      },
      // 表头
      columns: [
        { prop: "serialNo", label: "流水号", width: 250 },
        { prop: "orderNo", label: "订单号", width: 250 },
        { prop: "licenseNo", label: "车辆号牌", width: 150 },
        { prop: "vehicleNo", label: "车辆编号", width: 150 },
        { prop: "driverName", label: "司机姓名", width: 100 },
        { prop: "realFee", label: "实际支付" },
        { prop: "driverIncome", label: "司机收入" },
        { prop: "companyIncome", label: "平台收入" },
        { prop: "created", label: "记录时间" }
      ],
    };
  },
};
</script>

<style scoped></style>
